import {
  Button,
  CloseButton,
  Combobox,
  Text,
  useCombobox,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';

import classes from '../harvest-proof-status-filter/harvest-proof-status-filter.module.css';

type TcSmsFilterValue = 'true' | 'false';

interface HarvestProofTcSmsFilterProps {
  onChange: (value: TcSmsFilterValue) => void;
  onClear: () => void;
  value?: TcSmsFilterValue;
}

export function HarvestProofTcSmsFilter({
  onChange,
  onClear,
  value,
}: HarvestProofTcSmsFilterProps) {
  const { t } = useTranslation();
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const options = [
    { value: 'true' as const, label: t('common.yes') },
    { value: 'false' as const, label: t('common.no') },
  ];

  const selectedLabel = options.find((o) => o.value === value)?.label;

  return (
    <Combobox
      onOptionSubmit={(selected) => {
        onChange(selected as TcSmsFilterValue);
        combobox.closeDropdown();
      }}
      position="bottom-start"
      store={combobox}
    >
      <Combobox.Target>
        <Button
          className={classes.button}
          color="gray"
          fullWidth
          justify="space-between"
          onClick={() => combobox.toggleDropdown()}
          px="sm"
          rightSection={
            value ? (
              <CloseButton
                aria-label={t('common.clear')}
                onClick={(event) => {
                  event.stopPropagation();
                  onClear();
                }}
                onMouseDown={(event) => event.preventDefault()}
                size="sm"
              />
            ) : (
              <Combobox.Chevron />
            )
          }
          tt="initial"
          variant="light"
        >
          {value ? (
            <Text lineClamp={1} size="sm">
              {selectedLabel}
            </Text>
          ) : (
            <Text c="var(--mantine-color-placeholder)" size="sm">
              {t('harvest-proof.columns.tcSms')}
            </Text>
          )}
        </Button>
      </Combobox.Target>
      <Combobox.Dropdown>
        <Combobox.Options>
          {options.map((opt) => (
            <Combobox.Option key={opt.value} value={opt.value}>
              {opt.label}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}
